import {
  FilterDocumentTagFilter,
  FilterDocumentTagMatchMode,
} from '@griply/types';

const KNOWN_MATCH_MODES: FilterDocumentTagMatchMode[] = Object.values(
  FilterDocumentTagMatchMode,
);

export const resolveTagMatchMode = (
  tagFilter: FilterDocumentTagFilter | null | undefined,
): FilterDocumentTagMatchMode => {
  const raw = tagFilter?.matchMode;
  if (raw && KNOWN_MATCH_MODES.includes(raw)) {
    return raw;
  }
  if (tagFilter?.noTag && !tagFilter?.include?.length) {
    return FilterDocumentTagMatchMode.NoTag;
  }
  return FilterDocumentTagMatchMode.Any;
};
